import React from 'react';
import { Card, Grid, Icon, Stack, Text, Title } from 'library/ui';
import { FEATURES } from './shared';

export function ValuePropsStep() {
    return (
        <Stack gap="md">
            <Stack gap="sm">
                <Text size="sm" weight="bold" tone="accent">
                    Welcome to Tandem
                </Text>
                <Title size="h2">Reliable childcare staffing, in a day</Title>
            </Stack>
            <Grid columns={3} gap="md" collapseAt="sm">
                {FEATURES.map((feature) => (
                    <Card key={feature.key} padding="sm">
                        <Stack gap="sm">
                            <Icon icon={feature.icon} size="md" bgColor={feature.bg} iconColor={feature.color} />
                            <Text weight="bold">{feature.title}</Text>
                            <Text size="sm" tone="secondary" lineHeight="relaxed">
                                {feature.body}
                            </Text>
                        </Stack>
                    </Card>
                ))}
            </Grid>
        </Stack>
    );
}
